import * as axios from 'axios';

export const SAVE_SIGNATURE_START = "SAVE_SIGNATURE_START";
export const SAVE_SIGNATURE_SUCCESS = "SAVE_SIGNATURE_SUCCESS";
export const SAVE_SIGNATURE_FAILURE = "SAVE_SIGNATURE_FAILURE";

export const FETCH_SIGNATURE_START = "FETCH_SIGNATURE_START";
export const FETCH_SIGNATURE_SUCCESS = "FETCH_SIGNATURE_SUCCESS";
export const FETCH_SIGNATURE_FAILURE = "FETCH_SIGNATURE_FAILURE";

export const FETCH_TWEETS_START = "FETCH_TWEETS_START";
export const FETCH_TWEETS_SUCCESS = "FETCH_TWEETS_SUCCESS";
export const FETCH_TWEETS_FAILURE = "FETCH_TWEETS_FAILURE";

export const FETCH_INSTAGRAM_START = "FETCH_INSTAGRAM_START";
export const FETCH_INSTAGRAM_SUCCESS = "FETCH_INSTAGRAM_SUCCESS";
export const FETCH_INSTAGRAM_FAILURE = "FETCH_INSTAGRAM_FAILURE";

const URL = '/api/signature';

export const saveSignature = (email, signature, fields) => dispatch => {
    dispatch({ type: SAVE_SIGNATURE_START });

    var postData = {
        email, signature, fields
    };

    let axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
        }
    };

    axios.put(URL, postData, axiosConfig)
        .then((res) => {
            dispatch({ type: "SAVE_SIGNATURE_SUCCESS", payload: res })
        })
        .catch((err) => {
            dispatch({ type: "SAVE_SIGNATURE_FAILURE", payload: err })
        })
};

export const fetchSignature = email => dispatch => {
    dispatch({ type: FETCH_SIGNATURE_START });

    axios.get(URL + '?email=' + email)
        .then((response) => {

            if (!response.data && !response.data.url) {
                dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: { 'error': 'no url' } });
            }

            axios.get(response.data.url)
                .then((response) => {
                    dispatch({ type: "FETCH_SIGNATURE_SUCCESS", payload: response.data })
                })
                .catch((err) => {
                    dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: err })
                })
        })
        .catch((err) => {
            dispatch({ type: "FETCH_SIGNATURE_FAILURE", payload: err })
        })
};

export const fetchTweets = (data) => dispatch => {
    dispatch({ type: FETCH_TWEETS_START });

    const { username, count } = data;

    axios.get('/api/signature/getTweets' + '?username=' + username + '&count=' + count)
        .then((response) => {

            if (response.status != 200 && !response.data) {
                dispatch({ type: "FETCH_TWEETS_FAILURE", payload: { 'error': response.statusText } });
            }
            
            dispatch({ type: "FETCH_TWEETS_SUCCESS", payload: response.data })
        })
        .catch((err) => {
            dispatch({ type: "FETCH_TWEETS_FAILURE", payload: err })
        })
};

export const fetchInstagramLastPost = (data) => dispatch => {
    dispatch({ type: FETCH_INSTAGRAM_START });
    const { username } = data;
    axios.get('/api/signature/instagramLastPost' + '?username=' + username)
        .then((response) => {
            if (response.status != 200 && !response.data) {
                dispatch({ type: "FETCH_INSTAGRAM_FAILURE", payload: { 'error': response.statusText } });
            }
            dispatch({ type: "FETCH_INSTAGRAM_SUCCESS", payload: response.data })
        })
        .catch((err) => {
            dispatch({ type: "FETCH_INSTAGRAM_FAILURE", payload: err })
        })
};


// WEBPACK FOOTER //
// ./src/containers/signature/SignatureActions.js